import { create } from "zustand";

type ToastType = "success" | "error" | "warning" | "info";

interface ToastData {
  id: string;
  message: string;
  type: ToastType;
}

interface UIState {
  toasts: ToastData[];
  showToast: (message: string, type: ToastType) => void;
  removeToast: (id: string) => void;
  theme: "light" | "dark";
  setTheme: (theme: "light" | "dark") => void;
  toggleTheme: () => void;
}
const getInitialTheme = (): "light" | "dark" => {
  if (typeof window === "undefined") {
    return "light";
  }

  const stored = window.localStorage.getItem("theme");
  if (stored === "light" || stored === "dark") {
    return stored;
  }

  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }

  return "light";
};

export const useUIStore = create<UIState>((set, get) => ({
  toasts: [],
  showToast: (message, type) => {
    const id = Math.random().toString(36).substring(7);
    set({ toasts: [...get().toasts, { id, message, type }] });
  },
  removeToast: (id) => {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
  theme: getInitialTheme(),
  setTheme: (theme) => {
    set({ theme });
    if (typeof window !== "undefined") {
      window.localStorage.setItem("theme", theme);
    }
  },
  toggleTheme: () => {
    const next = get().theme === "dark" ? "light" : "dark";
    get().setTheme(next);
  },
}));
